export const connectSections = [
  { id: 'basic', label: 'Basic Info', complete: true },
  { id: 'scheduling', label: 'Scheduling', complete: true },
  { id: 'teams', label: 'Teams', complete: true },
  { id: 'registration', label: 'Registration', complete: true },
  { id: 'equipment', label: 'Equipment', complete: true },
  { id: 'pricing', label: 'Pricing', complete: true },
  { id: 'participants', label: 'Participants', complete: true },
  { id: 'staffing', label: 'Staffing', complete: false },
  { id: 'communications', label: 'Communications', complete: false },
  { id: 'status', label: 'Status', complete: false },
];

export const connectSidebar = [
  { id: 'dashboard', label: 'Dashboard', isNew: true },
  { id: 'insights', label: 'Program Insights', isNew: true },
  { id: 'finance', label: 'Finance Dashboard' },
  { id: 'training', label: 'Training & Events' },
  { id: 'members', label: 'Members' },
  { id: 'league', label: 'League Management' },
  { id: 'discounts', label: 'Discounts & Credits', indent: true },
  { id: 'support', label: 'League Support', indent: true },
  { id: 'comms', label: 'Communications', indent: true },
  { id: 'programsNew', label: 'Programs (New)', indent: true, isNew: true, active: true },
  { id: 'programs', label: 'Programs', indent: true },
  { id: 'roster', label: 'Roster Builder', indent: true },
];
